import { type CustomFunction, type OutputProperty } from '@blaze-shared/api-contracts-domain';
import { type SelectOption } from '@blaze-shared/shared-util';

export type OpenAiCustomFunctionForm = Omit<CustomFunction, 'outputSchema'> & {
  outputSchema: OutputPropertyForm[];
};

export interface OutputPropertyForm
  extends Omit<OutputProperty, 'dataType' | 'enums' | 'isRequired'> {
  enums?: string; // For 'enum' type
  isOptional?: boolean; // For 'isRequired' field
  dataType: OutputPropertySupportedDataTypeForm;
}

export type OutputPropertySupportedDataTypeForm = OutputProperty['dataType'] | 'Enum' | 'Email';

export const OUTPUT_DATA_TYPE_OPTIONS: SelectOption<OutputPropertySupportedDataTypeForm, string>[] =
  [
    { label: 'String', value: 'String' },
    { label: 'Int', value: 'Int' },
    { label: 'Decimal', value: 'Decimal' },
    { label: 'Boolean', value: 'Bool' },
    { label: 'Date', value: 'Date' },
    { label: 'DateTime', value: 'DateTime' },
    { label: 'Time', value: 'Time' },
    { label: 'Duration', value: 'Duration' },
    { label: 'Email', value: 'Email' },
    { label: 'Options', value: 'Enum' },
    { label: 'Object', value: 'Item' },
  ];
